const airlines = [
  { id: "-1", name: "- -" },
  { id: "1", name: "Aegean Airlines" },
  { id: "2", name: "Aer Lingus" },
  { id: "3", name: "Aeroflot" },
  { id: "4", name: "Aerolineas Argentinas" },
  { id: "5", name: "Aeromexico" },
  { id: "6", name: "Air Austral" },
  { id: "7", name: "Air Canada" },
  { id: "8", name: "Air Caraibes" },
  { id: "9", name: "Air China" },
  { id: "10", name: "Air Europa" },
  { id: "11", name: "Air France" },
  { id: "12", name: "Air India" },
  { id: "13", name: "Air India Express" },
  { id: "14", name: "Air Italy" },
  { id: "15", name: "Air Namibia" },
  { id: "16", name: "Air New Zealand" },
  { id: "17", name: "Air Serbia" },
  { id: "18", name: "Air Tahiti Nui" },
  { id: "19", name: "Air Transat" },
  { id: "20", name: "Air Vanuatu" },
  { id: "21", name: "AirAsia" },
  { id: "22", name: "AirAsia X" },
  { id: "23", name: "Aircalin" },
  { id: "24", name: "Alaska Airlines" },
  { id: "25", name: "Alitalia" },
  { id: "26", name: "Allegiant" },
  { id: "27", name: "American Airlines" },
  { id: "28", name: "ANA" },
  { id: "29", name: "Asiana" },
  { id: "30", name: "AtlasGlobal" },
  { id: "31", name: "Austrian" },
  { id: "32", name: "Avianca" },
  { id: "33", name: "Azerbaijan Hava Yollary" },
  { id: "34", name: "Azores Airlines" },
  { id: "35", name: "Azul" },
  { id: "36", name: "Bangkok Airways" },
  { id: "37", name: "bmi regional" },
  { id: "38", name: "British Airways" },
  { id: "39", name: "Brussels Airlines" },
  { id: "40", name: "Cathay Pacific" },
  { id: "41", name: "CEBU Pacific Air" },
  { id: "42", name: "China Airlines" },
  { id: "43", name: "China Eastern" },
  { id: "44", name: "China Southern" },
  { id: "45", name: "Condor" },
  { id: "46", name: "Copa Airlines" },
  { id: "47", name: "Croatia Airlines" },
  { id: "48", name: "Czech Airlines" },
  { id: "49", name: "Delta" },
  { id: "50", name: "Dragonair" },
  { id: "51", name: "easyJet" },
  { id: "52", name: "Edelweiss Air" },
  { id: "53", name: "Egyptair" },
  { id: "54", name: "EL AL" },
  { id: "55", name: "Emirates" },
  { id: "56", name: "Ethiopian Airlines" },
  { id: "57", name: "Etihad" },
  { id: "58", name: "Eurowings" },
  { id: "59", name: "EVA Air" },
  { id: "60", name: "Fiji Airways" },
  { id: "61", name: "Finnair" },
  { id: "62", name: "FlyBE" },
  { id: "63", name: "flydubai" },
  { id: "64", name: "FlyOne" },
  { id: "65", name: "French bee" },
  { id: "66", name: "Frontier" },
  { id: "67", name: "Garuda Indonesia" },
  { id: "68", name: "Germanwings" },
  { id: "69", name: "Gol" },
  { id: "70", name: "Gulf Air" },
  { id: "71", name: "Hainan Airlines" },
  { id: "72", name: "Hawaiian Airlines" },
  { id: "73", name: "Hong Kong Airlines" },
  { id: "74", name: "Iberia" },
  { id: "75", name: "Icelandair" },
  { id: "76", name: "IndiGo Airlines" },
  { id: "77", name: "InterJet" },
  { id: "78", name: "Japan Airlines" },
  { id: "79", name: "Jeju Air" },
  { id: "80", name: "Jet Airways" },
  { id: "81", name: "Jet2" },
  { id: "82", name: "JetBlue" },
  { id: "83", name: "Jetstar" },
  { id: "84", name: "Kenya Airways" },
  { id: "85", name: "KLM" },
  { id: "86", name: "Korean Air" },
  { id: "87", name: "La Compagnie" },
  { id: "88", name: "LATAM Brasil" },
  { id: "89", name: "LATAM Chile" },
  { id: "90", name: "Lion Airlines" },
  { id: "91", name: "LOT Polish Airlines" },
  { id: "92", name: "Lufthansa" },
  { id: "93", name: "Malaysia Airlines" },
  { id: "94", name: "Middle East Airlines" },
  { id: "95", name: "Nok Air" },
  { id: "96", name: "Nordwind Airlines" },
  { id: "97", name: "Norwegian Air Shuttle" },
  { id: "98", name: "Oman Air" },
  { id: "99", name: "Pakistan International Airlines" },
  { id: "100", name: "Peach" },
  { id: "101", name: "Pegasus Airlines" },
  { id: "102", name: "Philippine Airlines" },
  { id: "103", name: "Porter" },
  { id: "104", name: "Qantas" },
  { id: "105", name: "Qatar Airways" },
  { id: "106", name: "Regional Express" },
  { id: "107", name: "Rossiya - Russian Airlines" },
  { id: "108", name: "Royal Air Maroc" },
  { id: "109", name: "Royal Brunei" },
  { id: "110", name: "Royal Jordanian" },
  { id: "111", name: "Ryanair" },
  { id: "112", name: "S7 Airlines" },
  { id: "113", name: "SAS" },
  { id: "114", name: "Saudia" },
  { id: "115", name: "Scoot Airlines" },
  { id: "116", name: "Shanghai Airlines" },
  { id: "117", name: "Silkair" },
  { id: "118", name: "Singapore Airlines" },
  { id: "119", name: "Skylanes" },
  { id: "120", name: "South African Airways" },
  { id: "121", name: "Southwest" },
  { id: "122", name: "SpiceJet" },
  { id: "123", name: "Spirit" },
  { id: "124", name: "Spring Airlines" },
  { id: "125", name: "Spring Japan" },
  { id: "126", name: "SriLankan Airlines" },
  { id: "127", name: "Sun Country" },
  { id: "128", name: "Sunwing" },
  { id: "129", name: "SWISS" },
  { id: "130", name: "Swoop" },
  { id: "157", name: "Tarom" },
  { id: "131", name: "TAAG" },
  { id: "132", name: "TACA" },
  { id: "133", name: "TAP Portugal" },
  { id: "134", name: "THAI" },
  { id: "135", name: "Thomas Cook Airlines" },
  { id: "136", name: "Thomson" },
  { id: "137", name: "tigerair Australia" },
  { id: "138", name: "Transavia Airlines" },
  { id: "139", name: "TUIfly" },
  { id: "140", name: "Tunis Air" },
  { id: "141", name: "Turkish Airlines" },
  { id: "142", name: "Ukraine International" },
  { id: "143", name: "United" },
  { id: "144", name: "UTair Aviation" },
  { id: "145", name: "Vanilla Air" },
  { id: "146", name: "Vietnam Airlines" },
  { id: "147", name: "Virgin Atlantic" },
  { id: "148", name: "Virgin Australia" },
  { id: "149", name: "Vistara" },
  { id: "150", name: "Viva Aerobus" },
  { id: "151", name: "Volaris" },
  { id: "152", name: "Volotea" },
  { id: "153", name: "Vueling Airlines" },
  { id: "154", name: "WestJet" },
  { id: "155", name: "Wizzair" },
  { id: "156", name: "WOW air" },
];

export default airlines;



// WEBPACK FOOTER //
// ./src/constants/airlines.js